import moment from 'moment-timezone'
import { VideoCallType } from 'src/graphql.generated'

export type CurrentOrUpcomingCall = {
  callType: VideoCallType
  startTime: Date
  endTime: Date
}

export const CALL_LABELS: Record<VideoCallType, string> = {
  [VideoCallType.Intake]: 'Intake call',
  [VideoCallType.InProgram]: 'Check-in call',
}

export const shouldShowCallTodayIndicator = (
  currentOrUpcomingCall: CurrentOrUpcomingCall | null | undefined
): boolean => {
  if (!currentOrUpcomingCall) {
    return false
  }

  const now = moment()

  return (
    moment(currentOrUpcomingCall.endTime).isAfter(now) && moment(currentOrUpcomingCall.startTime).isSame(now, 'day')
  )
}

export const callTodayLabel = (callType: VideoCallType, startTime: Date): string =>
  `${CALL_LABELS[callType]} today at ${moment(startTime).format('LT')}`
